var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card h-100" }, [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-between card-header",
        class: `card-header-${_vm.category}`,
      },
      [
        _c("h3", { staticClass: "m-0" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.category === "female"
                  ? _vm.T.coderOfTheMonthFemale
                  : _vm.T.coderOfTheMonth
              ) +
              " "
          ),
        ]),
        _c(
          "a",
          {
            staticClass: "card-header-help",
            attrs: { href: _vm.CoderOfTheMonthPolicyURL },
          },
          [
            _c("font-awesome-icon", {
              attrs: { icon: ["fas", "info-circle"] },
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "card-body d-flex flex-column justify-content-center text-center",
      },
      [
        !_vm.coderOfTheMonth.is_private
          ? _c(
              "a",
              { attrs: { href: `/profile/${_vm.coderOfTheMonth.username}/` } },
              [
                _c("img", {
                  attrs: {
                    src: _vm.coderOfTheMonth.gravatar_92,
                    height: "80",
                    width: "80",
                    alt: _vm.coderOfTheMonth.username,
                  },
                }),
              ]
            )
          : _vm._e(),
        _c(
          "h4",
          { staticClass: "card-title" },
          [
            _c("omegaup-user-username", {
              attrs: {
                classname: _vm.coderOfTheMonth.classname,
                linkify: true,
                username: _vm.coderOfTheMonth.username,
                country: _vm.coderOfTheMonth.country_id,
              },
            }),
          ],
          1
        ),
        !_vm.coderOfTheMonth.is_private
          ? [
              _c("div", { staticClass: "card-text" }, [
                _vm._v(" " + _vm._s(_vm.coderOfTheMonth.name) + " "),
              ]),
              _vm.coderOfTheMonth.school
                ? _c("div", { staticClass: "card-text" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: `/schools/profile/${_vm.coderOfTheMonth.school_id}/`,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.coderOfTheMonth.school) + " ")]
                    ),
                  ])
                : _vm._e(),
              _vm.coderOfTheMonth.state && _vm.coderOfTheMonth.country !== "xx"
                ? _c("div", { staticClass: "card-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.coderOfTheMonth.state) +
                        ", " +
                        _vm._s(_vm.coderOfTheMonth.country) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              _vm.category == "female"
                ? "/coderofthemonth/female/"
                : "/coderofthemonth/",
          },
        },
        [_vm._v(_vm._s(_vm.T.coderOfTheMonthFullList))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }